import React, { useState, useMemo, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const carLines = [
  "ACCENT/VERNA 24",
  "ACCENT/VERNA 18",
  "ACCENT/VERNA 20",
  "CRETA 22",
  "CRETA 25",
  "CUSTIN 20",
  "ELANTRA 16",
  "ELANTRA 19",
  "ELANTRA 20",
  "GRAND I10 14",
  "GRAND I10 17",
  "GRAND SANTA FE 16",
  "KONA 18",
  "PALISADE 19",
  "PALISADE 22",
  "SANTA FE 12",
  "SANTA FE 15",
  "SANTA FE 18",
  "SANTA FE 20",
  "SANTA FE 22",
  "SANTA FE 24",
  "SANTA FE HYBRID 20",
  "SANTA FE HYBRID 24",
  "STARGAZER 22",
  "TUCSON 15",
  "TUCSON 18",
  "TUCSON 21",
  "TUCSON 24",
  "TUCSON HYBRID 24",
  "VENUE 19",
  "DÒNG XE KHÁC",
];

const partGroups = [
  "ADAS & cảm biến nâng cao",
  "Bánh xe & lốp",
  "Bảo dưỡng & tiêu hao",
  "Chăm sóc xe & hóa chất",
  "Chiếu sáng & tín hiệu",
  "Điều hòa & sưởi",
  "Động cơ",
  "Gara & dụng cụ",
  "Gạt mưa & rửa kính",
  "Hệ thống điện & điều khiển",
  "Hệ thống lái & treo",
  "Hệ thống làm mát",
  "Hệ thống nhiên liệu",
  "Hệ thống phanh",
  "Hệ thống truyền động & hộp số",
  "Hệ thống xả & tăng áp",
  "Nội thất & tiện nghi",
  "Thân xe & ngoại thất",
];

// eslint-disable-next-line no-unused-vars
const subCategoriesByGroup = {
  "Lốp xe, mâm, phụ kiện bánh xe": [
    "Bộ vá lốp",
    "Bơm lốp xe",
    "Cảm biến áp suất lốp",
    "Lốp xe",
    "Phụ kiện bánh xe",
  ],
  "Dầu và các loại chất lỏng ô tô": [
    "Dầu động cơ",
    "Dầu hộp số tự động",
    "Bộ thay dầu hộp số tự động",
    "Dầu hộp số /dầu bánh răng",
    "Dầu vi sai",
    "Dầu hộp phân phối",
    "Dầu trợ lực lái",
    "Dầu thủy lực",
    "Nước làm mát",
    "Dầu phanh",
    "Nước rửa kính",
    "Dung dịch urê (AdBlue)",
    "Phụ gia dầu",
    "Phụ gia nhiên liệu",
    "Phụ gia hệ thống thủy lực",
    "Phụ gia dầu hộp số",
    "Phụ gia và dung dịch làm sạch",
  ],
  "Hệ thống phanh": [
    "Má phanh",
    "Bộ phụ kiện má phanh đĩa",
    "Đĩa phanh",
    "Tấm đế phanh",
    "Bộ phụ kiện guốc phanh",
    "Cùm phanh",
    "Bộ sửa cùm phanh",
    "Bộ ống dẫn hướng cùm phanh",
    "Giá đỡ cùm phanh",
    "Piston cùm phanh",
    "Ốc cố định đĩa phanh",
    "Phanh tay",
    "Cáp phanh tay",
    "Má phanh tay",
    "Bộ sửa chữa xi lanh phanh bánh xe",
    "Ống mềm phanh",
    "Dầu phanh",
    "Ống dẫn dầu phanh",
    "Ống chân không",
    "Bình chứa dầu phanh",
    "Cảm biến ABS",
    "Công tắc đèn phanh",
    "Bơm chân không",
    "Bộ trợ lực phanh",
    "Dụng cụ phanh",
    "Keo khóa ren",
    "Mỡ bôi trơn đa dụng",
    "Keo/bột lắp ráp",
    "Mỡ bôi trơn dạng xịt",
    "Sơn cùm phanh",
  ],
  "Bộ lọc": [
    "Lọc dầu động cơ",
    "Lọc gió động cơ",
    "Bộ lọc bảo dưỡng",
    "Vỏ lọc dầu",
    "Ống nạp khí",
    "Giá đỡ hộp lọc gió",
    "Lọc gió phụ",
    "Lọc gió hiệu suất cao",
    "Lọc nhiên liệu",
    "Lọc gió cabin",
    "Bộ sấy khô khí",
    "Lọc dầu hộp số tự động",
    "Bộ thay dầu hộp số",
    "Dụng cụ tháo lọc",
  ],
  "Động cơ": [
    "Điện động cơ",
    "Cảm biến O2",
    "ECU động cơ",
    "Ốc xả dầu",
    "Dầu động cơ",
    "Gioăng ốc xả dầu",
    "Que thăm dầu",
    "Cácte dầu",
    "Bơm dầu",
    "Công tắc áp suất dầu",
    "Két làm mát dầu",
    "Cảm biến mức dầu",
    "Ống dầu turbo",
    "Cảm biến nhiệt độ dầu",
    "Dây curoa cam",
    "Bộ xích cam",
    "Xích cam",
    "Puly tăng đai cam",
    "Bộ căng xích cam",
    "Puly dẫn hướng đai cam",
    "Dây curoa tổng",
    "Bộ căng đai",
    "Bộ dây curoa tổng",
    "Puly dẫn hướng đai",
    "Bộ căng đai nhiều rãnh",
    "Puly trục khuỷu",
    "Bộ bơm nước + dây curoa",
    "Gioăng nắp cò",
    "Gioăng quy lát",
    "Bu lông đầu quy lát",
    "Bộ gioăng quy lát",
    "Nắp châm dầu",
    "Con đội thủy lực",
    "Phớt xupap",
    "Xupap xả",
    "Trục cam",
    "Xupap nạp",
    "Cò mổ",
    "Bộ gioăng nắp cò",
    "Van EGR",
    "Gioăng EGR",
    "Két làm mát EGR",
    "Lọc dầu động cơ",
    "Lọc gió động cơ",
    "Lọc nhiên liệu",
    "Ống gió nạp",
    "Lọc gió thể thao",
    "Thông hơi cácte",
    "Ống thông hơi nắp máy",
    "Chân máy",
    "Phớt dầu trục khuỷu",
    "Xéc măng",
    "Bạc thanh truyền",
    "Gioăng cácte",
    "Bạc trục khuỷu",
    "Bộ gioăng động cơ",
    "Piston",
    "Tấm chắn gầm",
    "Bánh đà",
    "Bạc chặn trục khuỷu",
    "Trục khuỷu",
    "Gioăng cổ hút",
    "Gioăng cổ xả",
    "Cổ hút",
    "Bơm nước động cơ",
    "Van hằng nhiệt",
    "Bộ lắp turbo",
    "Két làm mát",
    "Cảm biến nhiệt độ nước",
    "Nắp bình nước phụ",
    "Dung dịch làm mát",
    "Gioăng nước làm mát",
    "Quạt làm mát",
    "Nắp két nước",
    "Gioăng bơm nước",
    "Ống nước sưởi",
    "Bobin đánh lửa",
    "Cảm biến trục cam",
    "Cảm biến trục khuỷu",
    "Dây cao áp",
    "Bugi sấy",
    "Bộ chia điện",
    "Bộ điều khiển bugi sấy",
    "Đầu nối bugi",
    "Cảm biến lưu lượng khí nạp",
    "Turbo tăng áp",
    "Bướm ga",
    "Gioăng turbo",
    "Ống khí tăng áp",
    "Van điều khiển áp suất turbo",
    "Cảm biến áp suất cổ hút",
    "Cảm biến nhiệt độ khí nạp",
    "Cáp Bowden",
    "Van chuyển hướng khí",
    "Bơm chân không",
    "Gioăng kim phun",
    "Kim phun nhiên liệu",
    "Bơm nhiên liệu cao áp",
    "Van điều áp nhiên liệu",
    "Bộ phân phối nhiên liệu",
    "Cảm biến áp suất nhiên liệu",
    "Đường ống nhiên liệu",
    "Bộ chế hòa khí và linh kiện",
    "Cảm biến mức nhiên liệu",
    "Bộ dụng cụ động cơ",
  ],
  "Hệ thống rửa kính chắn gió": [
    "Cần gạt mưa kính lái",
    "Tay cần gạt mưa",
    "Lưỡi gạt mưa",
    "Gạt mưa kính sau",
    "Bơm nước rửa kính",
    "Nước rửa kính",
    "Bình chứa nước rửa kính",
    "Vòi phun nước rửa kính",
    "Hệ thống rửa đèn pha",
    "Khớp nối ống rửa kính",
  ],
  "Hệ thống đánh lửa và bugi sấy": [
    "Cuộn đánh lửa",
    "Bugi sấy",
    "Bộ điều khiển bugi sấy",
    "Dây cao áp",
    "Đầu chụp bugi",
    "Cảm biến trục khuỷu",
    "Cảm biến trục cam",
    "Bộ chia điện",
    "Dụng cụ kiểm tra đánh lửa",
    "ECU động cơ",
  ],
  "Hệ thống treo bánh xe và tay đòn lái": [
    "Moay-ơ bánh xe",
    "Bạc đạn bánh xe",
    "Phớt moay-ơ",
    "Rotuyn cân bằng",
    "Cao su thanh cân bằng",
    "Thanh cân bằng",
    "Càng A",
    "Cao su càng A",
    "Bộ sửa càng A",
    "Bu lông chỉnh camber",
    "Rotuyn trụ",
    "Rotuyn lái ngoài",
    "Rotuyn lái trong",
    "Chụp bụi thước lái",
    "Bu lông và đai ốc bánh xe",
    "Đai ốc bánh xe",
    "Ốc chống trộm bánh xe",
    "Đệm mở rộng bánh xe",
    "Chân máy",
    "Dụng cụ sửa khung gầm",
    "Bạc đạn trục",
    "Giá đỡ trục",
    "Cảm biến ABS",
    "Bát bèo giảm xóc",
    "Chụp bụi và cục chặn giảm xóc",
    "Đế lò xo",
    "Nhíp lá",
    "Chân giảm xóc",
    "Bạc đạn moay-ơ",
  ],
  "Hệ thống treo": [
    "Giảm xóc",
    "Lò xo",
    "Bát giảm xóc",
    "Chụp bụi & cao su giảm chấn",
    "Bộ kit treo",
    "Đế lò xo",
    "Nhíp lá",
    "Dụng cụ tháo lò xo & giảm xóc",
    "Bu lông chỉnh camber",
    "Giá đỡ giảm xóc",
    "Máy nén khí treo khí",
    "Dầu thủy lực",
    "Rơ-le điều khiển cân bằng",
  ],
  "Hệ thống điện": [
    "Máy phát điện",
    "Máy đề",
    "Ắc quy",
    "Phụ tùng máy phát",
    "Puly máy phát",
    "Chổi than đề",
    "Công tắc đề",
    "Phụ tùng máy đề",
    "Bóng đèn cos",
    "Bóng đèn pha",
    "Bóng đèn sương mù",
    "Bóng đèn xi nhan",
    "Bóng đèn hậu",
    "Bóng đèn biển số",
    "Bóng đèn phanh",
    "Bóng đèn lùi",
    "Cảm biến ABS",
    "Đèn hậu",
    "Đèn pha",
    "Đèn xi nhan",
    "Đèn biển số",
    "Dây điện tổng",
    "Đèn sương mù",
    "Công tắc đèn phanh",
    "Công tắc đèn lùi",
    "Đèn bảng đồng hồ",
    "Công tắc đèn",
    "Đèn phanh thứ ba",
    "Đèn nội thất",
    "Rơ le xi nhan",
    "Công tắc đèn cảnh báo",
    "Đèn cốp",
    "Phụ tùng đèn pha",
    "Bóng xenon",
    "Phụ tùng đèn hậu",
    "Tấm phản quang",
    "Đèn định vị",
    "Đèn sương mù sau",
    "Linh kiện đèn sương mù",
    "Đèn ban ngày (DRL)",
    "Bộ điều khiển đèn pha",
    "Đèn xoay cảnh báo",
    "Cửa kính điện",
    "Bơm nước rửa kính",
    "Ăng-ten",
    "Công tắc kính điện",
    "Cảm biến đỗ xe",
    "Điện trở quạt gió",
    "Cảm biến áp suất lốp",
    "Khóa cửa trung tâm",
    "Công tắc áp suất điều hòa",
    "Cảm biến nhiệt độ ngoài",
    "Còi xe",
    "Chìa khóa",
    "Dây công tơ mét",
    "Hệ thống chống trộm",
    "Cảm biến trục khuỷu",
    "Cảm biến trục cam",
    "Rơ le đa chức năng",
    "Bộ điều khiển bugi sấy",
    "Bộ dây kéo rơ-moóc",
    "Hộp cầu chì",
    "Cảm biến lưu lượng khí nạp",
    "Cảm biến oxy",
    "Van điều khiển áp suất tăng áp",
    "Cảm biến áp suất cổ hút",
    "Cảm biến áp suất chênh lệch",
    "Cảm biến nhiệt độ khí nạp",
    "Bộ điều áp nhiên liệu",
    "Cảm biến áp suất nhiên liệu",
    "Cảm biến mức nhiên liệu",
    "Cảm biến nhiệt độ nhiên liệu",
    "Gioăng cảm biến nhiên liệu",
    "Cảm biến nhiệt độ nước làm mát",
    "Công tắc áp suất dầu",
    "Cảm biến mức dầu",
    "Cảm biến nhiệt độ dầu",
    "Dụng cụ điện ô tô",
    "Công tắc ly hợp",
    "ECU hộp số tự động",
    "ECU động cơ",
    "Giảm xóc",
    "Lò xo",
    "Bát giảm xóc",
    "Chụp bụi & cao su giảm chấn",
    "Bộ kit treo",
    "Đế lò xo",
    "Nhíp lá",
    "Dụng cụ tháo lò xo & giảm xóc",
    "Bu lông chỉnh camber",
    "Giá đỡ giảm xóc",
    "Máy nén khí treo khí",
    "Dầu thủy lực",
    "Rơ-le điều khiển cân bằng",
  ],
  "Dây đai, xích và puly": [
    "Dây curoa tổng",
    "Bộ dây curoa tổng",
    "Tăng đai",
    "Tăng đai dây đa rãnh",
    "Puly dẫn hướng",
    "Bơm nước",
    "Dây cam",
    "Puly tăng dây cam",
    "Puly dẫn dây cam",
    "Xích cam",
    "Bộ xích cam",
    "Tăng xích cam",
    "Puly trục khuỷu",
    "Puly máy phát một chiều",
    "Dụng cụ xích/dây",
  ],
  "Hệ thống làm mát": [
    "Van hằng nhiệt",
    "Gioăng ống nước làm mát",
    "Két nước / bộ làm mát",
    "Nắp bình nước phụ",
    "Ống két nước",
    "Nắp két nước",
    "Ống sưởi két sưởi",
    "Bơm nước",
    "Bộ dây curoa tổng",
    "Phớt bơm nước",
    "Nước làm mát",
    "Gioăng nước làm mát",
    "Nước cất",
    "Cảm biến nhiệt độ nước làm mát",
    "Cảm biến nhiệt độ dầu",
    "Quạt làm mát",
    "Ống dầu",
    "Két làm mát dầu",
    "Dụng cụ hệ thống làm mát",
    "Dung dịch vệ sinh két nước",
    "Keo chống rò két nước",
    "Keo làm kín bề mặt",
    "Keo làm kín đa dụng",
  ],
  "Thân xe (khung vỏ)": [
    "Gương chiếu hậu ngoài",
    "Mặt gương",
    "Ốp gương",
    "Gương chiếu hậu trong",
    "Ty chống cốp",
    "Ty chống capo",
    "Lòng dè chắn bùn",
    "Tai xe",
    "Ốp mở rộng hốc bánh",
    "Đèn hậu",
    "Đèn pha",
    "Đèn xi nhan",
    "Đèn sương mù",
    "Đèn biển số",
    "Đèn phanh thứ ba",
    "Tấm phản quang",
    "Phụ tùng đèn pha",
    "Đèn sương mù sau",
    "Ốp đèn sương mù",
    "Phụ tùng đèn hậu",
    "Đèn định vị",
    "Linh kiện đèn sương mù",
    "Đèn chạy ban ngày (DRL)",
    "Đèn lùi",
    "Đèn pha chiếu xa",
    "Lưới thông gió",
    "Cản xe",
    "Lưới tản nhiệt",
    "Giá đỡ cản",
    "Nẹp trang trí cản",
    "Khung cản",
    "Nắp móc kéo",
    "Cảm biến đỗ xe",
    "Cánh gió",
    "Giá gắn biển số",
    "Bóng đèn pha",
    "Bóng đèn sương mù",
    "Bóng đèn xi nhan",
    "Bóng đèn cos",
    "Bóng đèn hậu",
    "Bóng đèn biển số",
    "Bóng đèn phanh",
    "Bóng xenon",
    "Bóng đèn lùi",
    "Nắp capo",
    "Khóa cửa",
    "Bộ phận cửa xe",
    "Tay nắm cửa",
    "Nẹp trang trí",
    "Cửa sau",
    "Ổ khóa cửa",
    "Khóa trung tâm",
    "Gioăng cửa",
    "Gioăng kính",
    "Khóa cốp",
    "Công tắc đề",
    "Bình nhiên liệu",
    "Giá đỡ khóa",
    "Bậc cửa",
    "Thanh bảo vệ gầm",
    "Điểm đặt kích",
    "Thành thân xe",
    "Giá đỡ trục",
    "Logo xe",
    "Kính cửa bên",
    "Tấm sửa chữa gầm",
    "Kính chắn gió",
  ],
  "Hệ thống sưởi và thông gió": [
    "Điện trở quạt gió",
    "Bộ trao đổi nhiệt",
    "Bơm nước phụ",
    "Ống nước bộ sưởi",
    "Bộ chấp hành cửa gió nhiệt",
    "Cảm biến nhiệt độ ngoài",
    "Bugi sấy bộ sưởi phụ",
    "Lọc gió cabin",
    "Motor quạt gió",
  ],
  "Gioăng và vòng làm kín": [
    "Gioăng cổ hút",
    "Gioăng ống xả",
    "Gioăng turbo",
    "Gioăng cổ xả",
    "Bộ lắp turbo",
    "Gioăng EGR",
    "Gioăng nắp cò",
    "Gioăng quy lát",
    "Phớt xupap",
    "Gioăng ốc xả dầu",
    "Phớt trục khuỷu",
    "Gioăng cacte",
    "Bộ gioăng động cơ",
    "Gioăng kim phun",
    "Gioăng bơm nhiên liệu",
    "Phớt bơm cao áp",
    "Gioăng ống nhiên liệu",
    "Gioăng nước làm mát",
    "Phớt bơm nước",
    "Gioăng ống nước",
    "Phớt trục vi sai",
    "Phớt hộp số",
    "Phớt trục truyền động",
    "Gioăng kính",
    "Gioăng cửa",
    "Phớt moay-ơ bánh xe",
  ],
  "Hệ thống xả": [
    "Cảm biến oxy",
    "Bộ lắp hệ thống xả",
    "Ống giảm thanh giữa",
    "Ống xả",
    "Ống xả mềm",
    "Đầu ống xả trang trí",
    "Tấm chắn nhiệt",
    "Van ống xả",
    "Giá đỡ ống xả",
    "Gioăng ống xả",
    "Cùm kẹp ống xả",
    "Khớp kẹp hệ thống xả",
    "Cao su treo ống xả",
    "Gioăng cổ xả",
    "Van EGR",
    "Gioăng EGR",
    "Két làm mát EGR",
    "Lọc hạt diesel",
    "Cảm biến áp suất DPF",
    "Dung dịch vệ sinh DPF",
    "Module phun dung dịch",
    "Turbo tăng áp",
    "Gioăng turbo",
    "Ống khí nạp tăng áp",
    "Van điều khiển áp suất turbo",
    "Ống dầu turbo",
    "Van xả áp turbo",
  ],
  "Nội thất xe": [
    "Ty chống cốp",
    "Bộ nâng kính điện",
    "Công tắc kính điện",
    "Tay quay kính",
    "Cốp xe",
    "Thảm sàn",
    "Núm cần số",
    "Bàn đạp và ốp bàn đạp",
    "Gương chiếu hậu trong",
    "Giá để cốc",
    "Tấm che nắng",
    "Ốp nội thất",
    "Dây an toàn",
    "Khóa cửa",
    "Tay nắm cửa",
    "Công tắc đề",
    "Khóa trung tâm",
    "Ổ khóa",
    "Chìa khóa",
    "Ăng-ten",
    "Cảm biến đỗ xe",
    "Đèn bảng tốc độ",
    "Công tắc đèn",
    "Công tắc đèn phanh",
    "Cáp đồng hồ tốc độ",
    "Công tắc đèn lùi",
    "Công tắc đèn cảnh báo",
    "Bàn đạp ga",
    "Rơ-le đa chức năng",
    "Đèn nội thất",
    "Đèn cửa",
    "Đèn cốp",
    "Rơ-le xi nhan",
    "Công tắc đèn sương mù",
    "Điện trở quạt gió",
    "Bơm nước phụ",
    "Cảm biến nhiệt độ ngoài",
    "Công tắc côn",
  ],
  "Hệ thống nhiên liệu": [
    "Lọc nhiên liệu",
    "Bơm nhiên liệu",
    "Ống nhiên liệu",
    "Gioăng bơm nhiên liệu",
    "Ống nhiên liệu",
    "Gioăng ống nhiên liệu",
    "Bơm nhiên liệu trong bình",
    "Bình nhiên liệu",
    "Kim phun nhiên liệu",
    "Gioăng kim phun",
    "Bướm ga",
    "Bơm cao áp",
    "Bộ phân phối nhiên liệu",
    "ECU động cơ",
    "Van điều áp nhiên liệu",
    "Vỏ lọc dầu",
    "Cảm biến lưu lượng khí nạp",
    "Cáp Bowden",
    "Bàn đạp ga",
    "Bộ chế hòa khí",
    "Cảm biến oxy",
    "Cảm biến áp suất nhiên liệu",
    "Cảm biến mức nhiên liệu",
    "Gioăng cảm biến mức nhiên liệu",
    "Cảm biến nhiệt độ nhiên liệu",
    "Dụng cụ hệ thống nhiên liệu",
    "Phớt bơm cao áp",
    "Nắp bình nhiên liệu",
  ],
  "Hệ thống lái": [
    "Rotuyn lái ngoài",
    "Thanh lái",
    "Rotuyn lái trong",
    "Chụp bụi thước lái",
    "Rotuyn trụ",
    "Dụng cụ hệ thống lái",
    "Bình dầu trợ lực lái",
    "Dầu trợ lực lái",
    "Thước lái",
    "Bộ sửa thước lái",
    "Khớp các đăng lái",
    "Trụ lái",
    "Cần điều khiển cột lái",
  ],
  "Hệ thống ly hợp (côn)": [
    "Bộ ly hợp",
    "Bi tê trung tâm",
    "Bi tê",
    "Bàn ép ly hợp",
    "Cáp côn",
    "Bàn đạp và ốp bàn đạp",
    "Công tắc côn",
    "Bánh đà",
    "Dụng cụ căn ly hợp",
    "Dung dịch vệ sinh côn phanh",
  ],
  "Trục truyền động & khớp nối": [
    "Chụp bụi láp",
    "Khớp láp",
    "Khớp tripod",
    "Trục láp",
    "Phớt trục láp",
    "Bạc đạn trục láp giữa",
  ],
  "Móc kéo và phụ kiện": [
    "Bộ dây điện móc kéo",
    "Thanh móc kéo",
    "Nắp móc kéo",
    "Bộ móc kéo",
  ],
  "Hệ thống truyền động / hộp số": [
    "Dầu hộp số",
    "Lọc dầu hộp số tự động",
    "Phớt hộp số",
    "Bộ thay dầu hộp số tự động",
    "Dầu hộp số tự động",
    "Két làm mát dầu hộp số",
    "Núm cần số",
    "Công tắc đèn lùi",
    "ECU hộp số tự động",
    "Van chuyển số",
    "Bánh đà",
    "Bộ sửa hộp số",
    "Bạc đạn hộp số sàn",
    "Bộ sửa mặt bích hộp số",
  ],
  "Hệ thống điều hòa": [
    "Lọc gió cabin",
    "Bình hút ẩm điều hòa",
    "Dàn nóng điều hòa",
    "Dàn trao đổi nhiệt",
    "Máy nén điều hòa",
    "Ly hợp từ máy nén",
    "Van tiết lưu",
    "Motor quạt gió điều hòa",
    "Điện trở quạt gió",
    "Hệ thống điều khiển điều hòa",
    "Công tắc áp suất điều hòa",
    "Cảm biến nhiệt độ ngoài trời",
    "Motor cửa gió điều hòa",
  ],
  "Khoang chứa / hộp đựng": [
    "Bạc đạn bánh xe",
    "Bạc đạn giữa trục các đăng",
    "Phớt trục moay-ơ",
    "Bạc đạn trung gian trục truyền động",
    "Bạc đạn bi tê",
    "Bạc đạn bi tê trung tâm",
    "Bạc đạn thanh truyền",
    "Bạc đạn trục khuỷu",
    "Bạc đạn hộp số sàn",
  ],
  "Trục cardan & vi sai": [
    "Khớp nối cao su trục các đăng",
    "Bạc đạn giữa trục các đăng",
    "Phớt trục vi sai",
    "Bộ phận vi sai",
    "Bộ sửa vi sai",
    "Dầu hộp số / dầu vi sai",
    "Dầu hộp số tự động",
  ],
  "Bộ điều khiển, cảm biến, rơ-le": [
    "Cảm biến nhiệt độ",
    "Cảm biến nhiệt độ nước làm mát",
    "Cảm biến oxy (O2 sensor)",
    "Cảm biến áp suất chênh lệch",
    "Cảm biến ABS",
    "Công tắc đèn phanh",
    "Cảm biến trục khuỷu",
    "Cảm biến trục cam",
    "Bộ điều khiển bugi sấy",
    "ECU động cơ",
    "Hệ thống kính cửa điện",
    "Cảm biến hỗ trợ đỗ xe",
    "Cảm biến áp suất lốp",
    "Công tắc kính điện",
    "Cảm biến nhiệt độ ngoài trời",
    "Cảm biến lưu lượng khí nạp (MAF)",
    "Cảm biến áp suất ống nạp (MAP)",
    "Van điều khiển áp suất turbo",
    "Cảm biến nhiệt độ khí nạp",
    "Công tắc áp suất dầu",
    "Cảm biến mức dầu",
    "Cảm biến nhiệt độ dầu",
    "Công tắc đèn lùi",
    "Rơ-le xi nhan",
    "Công tắc đèn cảnh báo",
    "Bộ điều khiển đèn pha",
    "Rơ-le đa chức năng",
    "Rơ-le còi",
    "ECU hộp số tự động",
    "Điện trở quạt gió điều hòa",
    "Công tắc áp suất điều hòa",
    "Cảm biến áp suất nhiên liệu",
    "Van điều áp nhiên liệu",
    "Cảm biến mức nhiên liệu",
    "Cảm biến nhiệt độ nhiên liệu",
    "Bộ điều khiển khóa cửa trung tâm",
  ],
  "Bộ kit sửa chữa": [
    "Bộ sửa cùm phanh",
    "Bộ chốt trượt cùm phanh",
    "Bộ phụ kiện guốc phanh",
    "Bộ sửa xi lanh phanh bánh xe",
    "Phụ tùng máy phát điện",
    "Phụ tùng máy đề",
    "Bộ sửa càng A",
    "Bộ sửa hộp số",
    "Bộ sửa vi sai",
    "Bộ sửa mặt bích hộp số sàn",
    "Bộ sửa thước lái",
  ],
  "Ống và ống mềm": [
    "Ống nước két tản nhiệt",
    "Ống dầu",
    "Ống dầu phanh",
    "Ống dầu phanh cứng",
    "Ống chân không",
    "Ống khí tăng áp",
    "Ống gió lọc gió",
    "Ống thông hơi nắp máy (PCV hose)",
    "Ống dầu turbo",
    "Ống nhiên liệu",
    "Ống hồi nhiên liệu",
    "Ống nước sưởi",
    "Ống điều hòa",
    "Ống nước rửa kính",
  ],
  "Hệ thống chiếu sáng": [
    "Đèn pha trước",
    "Đèn hậu",
    "Bóng đèn cos",
    "Bóng đèn sương mù",
    "Bóng đèn xi nhan",
    "Bóng đèn pha",
    "Bóng đèn hậu",
    "Bóng đèn phanh",
    "Bóng đèn lùi",
    "Bóng đèn biển số",
    "Đèn chiếu sáng đồng hồ",
    "Đèn biển số",
    "Đèn xi nhan",
    "Đèn sương mù",
    "Đèn nội thất",
    "Đèn cửa",
    "Đèn cốp",
    "Đèn phụ",
    "Đèn sương mù sau",
    "Đèn định vị",
    "Đèn ban ngày (DRL)",
    "Đèn lùi",
    "Đèn pha chiếu xa",
    "Bóng đèn Xenon (HID)",
  ],
  "Độ xe / nâng cấp hiệu suất": [
    "Hệ thống treo thể thao",
    "Đĩa phanh thể thao",
    "Miếng đệm bánh xe",
    "Lọc gió thể thao",
    "ECU tuning / chip độ",
  ],
  "Phụ kiện lắp ráp / bộ gá lắp": [
    "Ống dẫn đa năng",
    "Đai siết ống",
    "Gioăng / vòng đệm đa năng",
    "Đinh tán",
    "Đai ốc",
    "Vít / bu lông nhỏ",
  ],
  "Hệ thống tuần hoàn khí xả (EGR)": [
    "Van EGR",
    "Bộ làm mát EGR",
    "Gioăng EGR",
  ],
  "Hệ thống tăng áp động cơ": [
    "Turbo tăng áp",
    "Ống khí tăng áp",
    "Bộ lắp turbo",
    "Gioăng turbo",
    "Van điều khiển áp suất turbo",
    "Ống dầu turbo",
    "Van xả áp turbo",
  ],
  "Hệ thống treo khí nén": ["Máy nén khí treo", "Rơ-le điều khiển độ cao"],
};

const groupsByCarLine = carLines.reduce((acc, line) => {
  acc[line] = partGroups;
  return acc;
}, {});

const isMobile = () =>
  typeof window !== "undefined" && window.innerWidth <= 768;

const Sidebar = ({ onPartSelect }) => {
  const OTHER_CAR_LINE = "DÒNG XE KHÁC";
  const [activeBrand, setActiveBrand] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };
  const panelAreaRef = useRef(null);

  const mobile = isMobile();

  const sortedCarLines = useMemo(
    () =>
      [...carLines].sort((a, b) => {
        if (a === OTHER_CAR_LINE) return 1;
        if (b === OTHER_CAR_LINE) return -1;

        return a.localeCompare(b, "vi", {
          sensitivity: "base",
          numeric: true,
        });
      }),
    [],
  );

  const items = useMemo(
    () => sortedCarLines.map((line, index) => ({ line, index })),
    [sortedCarLines],
  );

  const handleHover = (brand) => {
    if (mobile) return;
    setActiveBrand(brand);
  };

  useEffect(() => {
    if (mobile) return undefined;

    const handleOutsideClick = (event) => {
      if (!panelAreaRef.current) return;
      if (!panelAreaRef.current.contains(event.target)) {
        setActiveBrand(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [mobile]);

  const handleClick = (brand) => {
    if (!mobile) return;
    setActiveBrand((prev) => (prev === brand ? null : brand));
  };

  const handleDesktopMouseLeave = () => {
    if (mobile) return;
    setActiveBrand(null);
  };

  const handlePartSelect = (partName) => {
    if (typeof onPartSelect === "function") {
      onPartSelect({
        carName: activeBrand,
        category: partName,
      });
    }
  };

  const activeModels = useMemo(() => {
    if (!activeBrand) return [];

    return [...(groupsByCarLine[activeBrand] || [])].sort((a, b) =>
      a.localeCompare(b, "vi", { sensitivity: "base", numeric: true }),
    );
  }, [activeBrand]);

  const activeBrandIndex = activeBrand
    ? sortedCarLines.indexOf(activeBrand)
    : -1;
  const modelPanelOffset =
    !mobile && activeBrandIndex >= 0 ? Math.min(activeBrandIndex * 18, 300) : 0;

  return (
    // Full-width brand area under the top nav; no fixed/absolute overlay on main content.
    <section className="sidebar-brand-section">
      {/* Search block — independent from the PHỤ TÙNG CHO XE sidebar */}
      <div className="sidebar-search-section">
        <form className="sidebar-search-form" onSubmit={handleSearch}>
          <div className="sidebar-search-input-wrap">
            <input
              className="sidebar-search-input"
              type="text"
              placeholder="Nhập thông tin phụ tùng"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              aria-label="Tìm kiếm phụ tùng"
            />
          </div>
          <button className="sidebar-search-btn" type="submit" aria-label="Tìm kiếm">
            <svg className="sidebar-search-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
              <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            </svg>
            <span>Tìm kiếm</span>
          </button>
        </form>
      </div>

      <div className="sidebar-brand-layout" onMouseLeave={handleDesktopMouseLeave}>
        <aside className="sidebar-brand-sidebar">
          <h2 className="sidebar-brand-title">PHỤ TÙNG CHO XE</h2>
          <ul className="sidebar-brand-list">
            {items.map(({ line }) => {
              const active = activeBrand === line;
              return (
                <li
                  key={line}
                  onMouseEnter={() => handleHover(line)}
                  onClick={() => handleClick(line)}
                  className={`sidebar-brand-item ${
                    active ? "sidebar-brand-item-active" : ""
                  }`}
                >
                  <div className="sidebar-brand-item-row">
                    <span className="sidebar-brand-label">{line}</span>
                  </div>
                </li>
              );
            })}
          </ul>
        </aside>

        {/* Desktop panel uses real CSS classes so model buttons always stack in one column. */}
        {!mobile && activeBrand && (
          <div
            ref={panelAreaRef}
            className="sidebar-model-panel"
            style={{ top: `${modelPanelOffset}px` }}
          >
            <div className="sidebar-model-header">
              <span className="sidebar-model-header-icon">🚘</span>
              <div>
                <h3 className="sidebar-model-title">{activeBrand}</h3>
                <p className="sidebar-model-subtitle">Nhóm phụ tùng</p>
              </div>
            </div>
            <div className="sidebar-model-list sidebar-level-2 sidebar-grid">
              {activeModels.map((model) => (
                <div
                  key={model}
                  className="sidebar-model-entry sidebar-item"
                >
                  <button
                    onClick={() => handlePartSelect(model)}
                    className="sidebar-model-item"
                  >
                    <span className="sidebar-model-icon">🚗</span>
                    <span className="sidebar-model-text">{model}</span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Mobile: model list stacks under brand list for easier touch interaction. */}
        {mobile && activeBrand && (
          <div className="sidebar-model-panel sidebar-model-panel-mobile">
            <div className="sidebar-model-header">
              <span className="sidebar-model-header-icon">🚘</span>
              <h3 className="sidebar-model-title">{activeBrand}</h3>
            </div>
            <div className="sidebar-model-list sidebar-level-2 sidebar-grid">
              {activeModels.map((model) => (
                <div key={model} className="sidebar-model-entry sidebar-item">
                  <div
                    onClick={() => handlePartSelect(model)}
                    className="sidebar-model-item"
                  >
                    <span className="sidebar-model-icon">🚗</span>
                    <span className="sidebar-model-text sidebar-model-text-mobile">
                      {model}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Sidebar;
